export default __webpack_public_path__ + "static/media/university.010e82c8.webp";